/**
 * Finery markets management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Pair } from './pair';

export interface FineryMarketsPairDto {
  id: number;
  pair: Pair;
  externalSymbol: string;
  lvl1: number;
  lvl2: number;
  lvl3: number;
  maxLoss: number;
  currentLoss: number;
}
